var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstHoodHeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 350,
    viewBox: "0 0 347 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3294 191.913C61.3053 189.94 51.0387 176.4 51.0387 176.4C51.0387 176.4 51.3996 169.976 52.1134 168.211C52.8273 166.446 55.3138 164.602 56.8778 163.856C58.4419 163.11 61.9952 163.142 61.9952 163.142C61.9952 163.142 61.6342 175.662 61.8428 176.866C62.0513 178.069 63.3267 178.349 63.3267 178.349H60.1022C64.1688 184.67 72.3421 191.913 72.3421 191.913L73.9302 192.53C73.9302 192.53 74.4436 199.236 73.473 201.281C72.5025 203.326 65.3078 206.07 65.0271 206.302C64.7463 206.535 64.2089 205.997 64.2089 205.997L63.7999 196.629L61.3294 191.913ZM61.3294 191.913C58.2815 194.295 54.7924 198.009 54.7924 198.009C44.8946 218.285 48.0308 257.532 48.0308 257.532H53.1481C53.1481 257.532 52.0573 262.071 52.0573 262.039C52.0573 262.007 47.0041 262.039 47.0041 262.039C47.0041 262.039 43.868 268.729 44.0043 287.49C44.1407 306.25 54.1106 328.115 54.1106 328.115H93.8381C93.8381 328.115 83.1863 311.28 83.5954 295.599C84.0045 279.918 87.7262 267.806 90.2207 262.994H83.1863C83.1863 262.994 77.1466 269.242 76.152 284.225C75.1655 299.208 76.5611 312.555 76.5611 312.555C76.5611 312.555 51.4637 306.756 44.9508 298.013",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1562 257.532H87.4936L83.1944 262.994L52.0653 262.031",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4936 257.532C87.4936 257.532 105.974 228.52 146.271 239.782M162.24 157.046C162.24 157.046 129.764 157.688 67.6178 187.365",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.271 239.782L152.206 242.958H188.966L177.801 228.007L177.191 199.741L178.314 175.173L177.905 162.573L179.646 157.046H162.24",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.343 99.408H181.009C181.009 99.408 177.873 99.5764 177.873 102.344C177.873 105.111 177.873 155.201 177.873 155.201L179.646 157.046L192.343 156.701V99.408Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.009 99.408C181.009 99.408 175.242 98.7262 175.274 102.825C175.306 106.924 175.274 151.728 175.274 151.728L177.865 155.209",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.411 157.046L175.282 151.72",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.646 157.046L182.645 168.925C182.645 168.925 187.185 173.184 193.498 170.457C199.81 167.73 194.933 164.209 194.933 164.209L193.554 161.859L190.562 156.757",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.314 175.173L207.43 171.724C206.475 168.171 195.824 161.859 195.824 161.859H193.554",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.865 161.851H178.314",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.206 242.958C152.206 242.958 163.403 247.153 172.21 260.949C181.017 274.737 180.263 291.26 180.263 291.26V328.124H482.803V234.456H494V-2L422.598 0.24585C422.598 0.24585 354.196 4.95411 299.317 26.1212C244.438 47.2883 221.563 80.6632 221.563 80.6632L203.62 106.138L192.343 124.217",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.408 0.414307L432.151 62.4318H246.925C246.925 62.4318 241.743 62.8088 236.449 70.5088",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.541 234.937H281.021",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.529 245.204H313.514C313.514 245.204 315.014 235.972 317.709 234.929",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.556 234.937C332.556 234.937 336.037 238.955 336.037 245.212H428.461L431.533 234.937",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.514 245.204L314.677 260.941C314.677 260.941 315.904 265.24 317.717 265.312C319.53 265.384 331.745 265.312 331.745 265.312C331.745 265.312 334.24 264.598 335.026 260.74C335.812 256.882 336.053 245.212 336.053 245.212",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.722 244.153L319.385 261.149H330.101L333.237 244.153L331.056 237.6H318.832L316.722 244.153Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.237 244.153H336.037",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.722 244.153H313.514",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.5 269.274C176.5 269.274 176 269.274 185.998 269.274H308.052V245.212",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.052 269.274V328.116",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.052 304.494L192.343 305.312V297.123H308.052H482.803",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.369 245.204C193.369 245.204 199.241 254.115 201.013 262.031H308.052H315.046",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.392 262.031V245.203L281.021 234.937H182.974",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 336.289C156.568 336.289 176.958 315.899 176.958 290.746C176.958 265.594 156.568 245.204 131.416 245.204C106.263 245.204 85.8733 265.594 85.8733 290.746C85.8733 315.899 106.263 336.289 131.416 336.289Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 316.493C145.636 316.493 157.163 304.966 157.163 290.746C157.163 276.526 145.636 264.999 131.416 264.999C117.196 264.999 105.669 276.526 105.669 290.746C105.669 304.966 117.196 316.493 131.416 316.493Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 332.278C154.353 332.278 172.948 313.684 172.948 290.746C172.948 267.809 154.353 249.214 131.416 249.214C108.478 249.214 89.8838 267.809 89.8838 290.746C89.8838 313.684 108.478 332.278 131.416 332.278Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 312.868C143.633 312.868 153.537 302.964 153.537 290.746C153.537 278.529 143.633 268.625 131.416 268.625C119.198 268.625 109.294 278.529 109.294 290.746C109.294 302.964 119.198 312.868 131.416 312.868Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 297.941C135.389 297.941 138.611 294.72 138.611 290.746C138.611 286.773 135.389 283.552 131.416 283.552C127.442 283.552 124.221 286.773 124.221 290.746C124.221 294.72 127.442 297.941 131.416 297.941Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.855 72.1289L192.343 153.356",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.174 73.1796H295.146C295.146 73.1796 302.91 71.5835 306.576 79.0028C306.576 79.0028 306.833 109.787 302.485 122.5C302.485 122.5 301.804 129.582 292.596 131.203C283.388 132.823 226.584 136.488 226.584 136.488C226.584 136.488 218.226 136.745 217.881 130.858L222.662 106.466",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.693 101.766C225.693 101.766 221.033 116.316 220.44 130.088C220.44 130.088 219.926 134.307 224.105 134.355C224.105 134.355 280.693 131.58 292.331 128.941C292.331 128.941 297.962 128.644 300.689 120.623C300.689 120.623 305.253 89.2778 304.442 80.9682C304.442 80.9682 304.571 77.1342 298.146 74.6558H243.147",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.031 199.645C260.031 199.645 265.742 194.528 273.498 199.645L272.624 219.152L266.76 221.919L260.897 219.152L260.031 199.645Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.268 203.022H265.196V219.505H268.268V203.022Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.196 204.762L262.229 206.399V217.612H265.509",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.268 204.762L271.396 206.351V217.612H268.268",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.76 201.899C267.793 201.899 268.629 201.062 268.629 200.03C268.629 198.998 267.793 198.161 266.76 198.161C265.728 198.161 264.891 198.998 264.891 200.03C264.891 201.062 265.728 201.899 266.76 201.899Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.43 234.456L209.339 240.07H286.853H314.717",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.235 240.07H430.001",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3266 178.341H65.9574C65.9574 178.341 67.0483 178.133 67.2167 176.906C67.3852 175.679 67.2167 164.923 67.2167 164.923C67.2167 164.923 67.3691 163.27 65.4762 163.134C63.5833 162.997 61.9951 163.134 61.9951 163.134",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1022 178.342H57.2869C57.2869 178.342 56.3645 178.622 57.2869 179.978C58.2093 181.333 71.0106 196.87 71.0106 196.87C71.0106 196.87 72.31 198.129 71.9411 202.773",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.263 314.015H482.803",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 277.343C133.263 277.343 134.761 275.846 134.761 273.999C134.761 272.151 133.263 270.654 131.416 270.654C129.569 270.654 128.071 272.151 128.071 273.999C128.071 275.846 129.569 277.343 131.416 277.343Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.629 294.091C150.476 294.091 151.973 292.594 151.973 290.746C151.973 288.899 150.476 287.402 148.629 287.402C146.782 287.402 145.284 288.899 145.284 290.746C145.284 292.594 146.782 294.091 148.629 294.091Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.716 294.091C116.564 294.091 118.061 292.594 118.061 290.746C118.061 288.899 116.564 287.402 114.716 287.402C112.869 287.402 111.372 288.899 111.372 290.746C111.372 292.594 112.869 294.091 114.716 294.091Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 310.839C133.263 310.839 134.761 309.341 134.761 307.494C134.761 305.647 133.263 304.149 131.416 304.149C129.569 304.149 128.071 305.647 128.071 307.494C128.071 309.341 129.569 310.839 131.416 310.839Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.677 305.312C144.524 305.312 146.022 303.815 146.022 301.968C146.022 300.12 144.524 298.623 142.677 298.623C140.83 298.623 139.333 300.12 139.333 301.968C139.333 303.815 140.83 305.312 142.677 305.312Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.882 283.198C121.729 283.198 123.227 281.701 123.227 279.854C123.227 278.006 121.729 276.509 119.882 276.509C118.035 276.509 116.537 278.006 116.537 279.854C116.537 281.701 118.035 283.198 119.882 283.198Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.487 283.198C145.335 283.198 146.832 281.701 146.832 279.854C146.832 278.006 145.335 276.509 143.487 276.509C141.64 276.509 140.143 278.006 140.143 279.854C140.143 281.701 141.64 283.198 143.487 283.198Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.882 304.983C121.729 304.983 123.227 303.486 123.227 301.639C123.227 299.791 121.729 298.294 119.882 298.294C118.035 298.294 116.537 299.791 116.537 301.639C116.537 303.486 118.035 304.983 119.882 304.983Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.855 72.1289L248.36 66.7549L246.933 66.7629C246.933 66.7629 239.898 66.4581 236.457 70.5167L192.351 134.66",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.352 66.7471H300.344C304.603 66.7471 308.052 70.196 308.052 74.4551V234.937",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.344 66.7471C300.344 66.7471 310.097 67.0599 310.506 72.0168C310.915 76.9737 310.506 234.929 310.506 234.929",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.964 56.4963C252.964 56.4963 292.604 28.0623 339.999 18.2046",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4141 335.414C44.633 336.195 43.3667 336.195 42.5857 335.414L29.8577 322.686C29.0767 321.905 29.0767 320.639 29.8578 319.858C30.6388 319.077 31.9051 319.077 32.6862 319.858L43.9999 331.172L55.3136 319.858C56.0946 319.077 57.361 319.077 58.142 319.858C58.9231 320.639 58.9231 321.905 58.142 322.686L45.4141 335.414ZM42.5858 198.086C43.3668 197.305 44.6332 197.305 45.4142 198.086L58.1421 210.814C58.9232 211.595 58.9232 212.861 58.1421 213.642C57.3611 214.423 56.0947 214.423 55.3137 213.642L44 202.328L32.6863 213.642C31.9052 214.423 30.6389 214.423 29.8579 213.642C29.0768 212.861 29.0768 211.595 29.8579 210.814L42.5858 198.086ZM41.9999 334L42 199.5L46 199.5L45.9999 334L41.9999 334Z",
    fill: "#2D9DC9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 336.5,
    x2: 347,
    y2: 336.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 251C49 251 49.6737 237.05 53.69 228.574C57.715 220.099 64.5225 219.607 70 219L63.2975 234.996L49 251Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347,
    height: 350,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstHoodHeight);
export default __webpack_public_path__ + "static/media/instHoodHeight.3021d1b7b7f26d6564ddcb061122bc6d.svg";
export { ForwardRef as ReactComponent };